(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('PhoneCallStatusDeleteController',PhoneCallStatusDeleteController);

    PhoneCallStatusDeleteController.$inject = ['$uibModalInstance', 'entity', 'PhoneCallStatus'];

    function PhoneCallStatusDeleteController($uibModalInstance, entity, PhoneCallStatus) {
        var vm = this;

        vm.phoneCallStatus = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PhoneCallStatus.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
